import { getData } from 'country-list';

export interface CountryOption {
  code: string;
  name: string;
}

let cachedCountries: CountryOption[] | null = null;

export function getCountryOptions(): CountryOption[] {
  if (!cachedCountries) {
    cachedCountries = getData()
      .map((entry: { code: string; name: string }) => ({ code: entry.code, name: entry.name }))
      .sort((a: CountryOption, b: CountryOption) => a.name.localeCompare(b.name));
    cachedCountries.push({ code: 'OTHER', name: 'Other' });
  }
  return cachedCountries;
}

export function getCountryName(code: string): string {
  const match = getCountryOptions().find(c => c.code === code);
  return match?.name ?? code;
}
